<script>
    import SingleFeature from "./SingleFeature.svelte";
</script>

<style>
    .container {
        box-sizing: border-box;
        position: relative;
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
    }

    .tagline {
        width: 100%;
        font-weight: 200;
        font-size: 80px;
        text-align: center;
        margin-top: 100px;
        margin-bottom: 150px;
    }

    .centerForBlogButton {
        width: 100%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
    }

    @media (max-width: 600px) {
        .centerForBlogButton {
            flex-flow: column nowrap;
        }
	}

    .blogButton {
        font-weight: 700;
        font-size: 15px;
        border: solid 1px white;
        height: 36px;
        line-height: 36px;
        padding: 0px 15px;
        border-radius: 18px;
        margin: 10px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
    }

    @media (max-width: 1000px) {
        .tagline {
            font-size: 50px;
        }
	}

    @media (max-width: 500px) {
        .tagline {
            font-size: 30px;
        }
	}

    .githubIcon {
        height: 100%;
        width: auto;
        margin-left: -15px;
        margin-right: 10px;
    }

</style>

<div class="container" id="features">
    <div class="tagline" data-aos="fade-in">Simple. Clear. Responsive.</div>
    <SingleFeature 
        title="It's simple" 
        description="We don’t make rocket science out of HTTP. Configuring and sending requests should be simple, quick and without distractions. That’s why we simplified UI flow so anybody can use httpiness immediately and efficiently. Httpiness is a simple solution for a simple problem."
    />
    <SingleFeature 
        title="Fast turnaround" 
        description="Developers often need to make multiple requests before they can send request they want to test. This is what we call slalom testing. Httpiness is built with this workflow in mind. It enables you to quickly select, configure and send requests. Let’s accelerate code-build-test cycle!"
    />
    <SingleFeature 
        title="Whole request in single view" 
        description="Single glimpse shows if request is right! We believe that user should see whole request at once in clear and understandable manner. No more separate tabs for every single part of request."
    />
    <SingleFeature 
        title="Structured URL" 
        description="Frustrated about long unreadable urls? Not sure where path ends and query starts? Httpiness automatically parses and formats url at every keystroke so you can see what your host, path, query and hash are."
    />
    <SingleFeature 
        title="Parameters on fingertips" 
        description="Define parametrized request once, and then only change parameters to configure it. Parameters are always visible and are shared between requests from same collection. You can configure multiple request simultaneously - by changing shared parameters."
    />
    <SingleFeature 
        title="Use third-party collections" 
        description="Import and convert Postman JSON collections v2.1 directly to httpiness. Majority of features from other major http clients is available in httpiness, however few are still missing. Don't worry, they are coming soon."
    />
    <SingleFeature
        title="Advanced secret management" 
        description="Lock sensitive data and store it securely in system's default credential manager instead of collection file. This way sensitive data cannot be accidentally shared with others who gain access to the collection and will be read from credential manager only when needed."
    />
    <SingleFeature 
        title="It's open-source" 
        description="Check out the source code and contribute at GitHub."
    />
    <div class="centerForBlogButton" data-aos="fade-in">
        <a href="https://github.com/bognikol/httpiness" rel="noreferrer" target="_blank" class="blogButton">
            <img class="githubIcon" src="./../images/github.svg" alt="github"/> Contribute at GitHub
        </a>
        or
        <a href="#/docs" target="_blank" class="blogButton">
            Read frequently asked questions
        </a>
    </div>
</div>
